import { apiFetch } from './client';
import type { AuthMeResponse } from './types';

export function getMe(): Promise<AuthMeResponse> {
  return apiFetch<AuthMeResponse>('/auth/me');
}
